/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateTimer = `subscription OnCreateTimer {
  onCreateTimer {
    id
    name
    startISOString
    endISOString
  }
}
`;
export const onUpdateTimer = `subscription OnUpdateTimer {
  onUpdateTimer {
    id
    name
    startISOString
    endISOString
  }
}
`;
export const onDeleteTimer = `subscription OnDeleteTimer {
  onDeleteTimer {
    id
    name
    startISOString
    endISOString
  }
}
`;
